import { useCallback, useEffect, useState } from 'react';

import useEmblaCarousel, { EmblaOptionsType } from 'embla-carousel-react';

export const useEmbla = (options?: EmblaOptionsType) => {
    const [viewportRef, emblaApi] = useEmblaCarousel(options);

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isPrevButtonEnabled, setIsPrevButtonEnabled] = useState(false);
    const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
    const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

    const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
    const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);
    const scrollTo = useCallback((index: number) => emblaApi?.scrollTo(index), [emblaApi]);
    const onSelect = useCallback(() => {
        if (emblaApi === undefined) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
        setIsPrevButtonEnabled(emblaApi.canScrollPrev());
        setIsNextButtonEnabled(emblaApi.canScrollNext());
    }, [emblaApi, setSelectedIndex]);
    const onResize = useCallback(() => {
        if (emblaApi === undefined) return;
        setScrollSnaps(emblaApi.scrollSnapList());
    }, [emblaApi]);

    useEffect(() => {
        if (emblaApi === undefined) return;
        onSelect();
        onResize();
        emblaApi.on('reInit', onSelect);
        emblaApi.on('select', onSelect);
        emblaApi.on('resize', onResize);

        return () => {
            emblaApi.off('reInit', onSelect);
            emblaApi.off('select', onSelect);
            emblaApi.off('resize', onResize);
        };
    }, [emblaApi, setScrollSnaps, onSelect, onResize]);

    return {
        emblaApi,
        viewportRef,
        selectedIndex,
        scrollSnaps,
        scrollPrev,
        scrollNext,
        scrollTo,
        isPrevButtonEnabled,
        isNextButtonEnabled,
    };
};
